<template>
    <div>
        <h1 class="display-1 font-weight-regular mb-4"></h1>

        <v-layout>
            <v-flex xs12 sm6 offset-sm3>
                <v-card>
                    <v-card-title primary-title>
                        <div class="text-xs-left">
                            <div class="headline font-weight-regular">{{ $t('login-title') }}</div>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-form ref="loginForm" v-model="valid" lazy-validation>
                            <v-text-field :label="$t('login')" :rules="[rules.required, rules.email]"
                                          v-model="username" required></v-text-field>
                            <v-text-field :label="$t('password')" :rules="[rules.required]"
                                          type="password" v-model="password" required></v-text-field>
                            <div>
                                <v-spacer></v-spacer>
                                <v-btn :disabled="!valid" color="primary" @click="submit" class="mt-4">
                                    {{ $t('sign-in') }}
                                </v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as types from '@/stores/types';
import store from '@/stores';

export default {
    store,
    data: function()
    {
        return {
            valid:    false,
            username: '',
            password: '',
            rules:    {
                required: value => !!value || this.$t('required'),
                email:    value =>
                {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                    return pattern.test(value) || this.$t('invalid-email');
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            userConnected:  'userConnected',
        }),
    },
    methods: {
        ...mapActions({
            login:       types.A_USER_LOGIN,
        }),
        /**
         * Validation du formulaire
         *
         * @author Fabien Bellanger
         */
        submit: function()
        {
            if (this.$refs.loginForm.validate())
            {
                this.login({
                    username: this.username,
                    password: this.password,
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
